import { render, staticRenderFns } from "./userShop.vue?vue&type=template&id=9c583e48"
import script from "./userShop.vue?vue&type=script&lang=js"
export * from "./userShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports